module.exports = __webpack_public_path__ + "static/media/6. Natha.df3a6f25.png";